export default {
  UP: 38,
  DOWN: 40,
  ENTER: 13,
  ESC: 27,
}
